'use client';

import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AuthApi } from '@/api';

interface UsePutCommentMutationParams {
  /** 수정 대상 댓글 id */
  commentId: number;
  /** 성공 시 상위에서 모드 종료와 스크롤 복원을 처리 */
  onSuccess?: () => void;
}

// 댓글 수정 API와 목록 재조회 처리만 담당하는 얇은 mutation 훅이다.
export const usePutCommentMutation = ({
  commentId,
  onSuccess,
}: UsePutCommentMutationParams) => {
  const { toast, toastError } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (contents: string) =>
      AuthApi['put:/wello/v2/auth/wello-comment/{welloCommentId}']({
        path: {
          welloCommentId: commentId,
        },
        body: {
          contents,
        },
      }),
    onSuccess: async () => {
      toast({ type: 'success', message: '댓글 수정완료' });

      // 수정 후에는 댓글 관련 화면들이 모두 새 데이터를 읽도록 전체 invalidate 한다.
      await queryClient.invalidateQueries();

      onSuccess?.();
    },
    onError: (error) => {
      toastError({ error });
    },
  });
};
